import { createAction, props } from '@ngrx/store';
import { UserProfile } from '../core/user-profile/user-profile';
import { Company } from '../core/company/company';
import { Pageable } from '../core/service/pageable';
import { Named } from '../core/util/named';

export const SetCompaniesList = createAction('admin-set-companies-list', props<{ companies: Pageable<Company> }>());
export const SetNamedSubject = createAction('admin-set-named-subject', props<{ subject: Named }>());
export const SetUsersList = createAction('admin-set-users-list', props<{ users: Pageable<UserProfile> }>());
